import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../utils/api';

// Read-only supplier rating: the average and count, then a collapsed "Customer reviews (N)" section.
// Reviews are submitted only from My Orders.
export default function SupplierReviews({ supplier, showSummary = true }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [reviews, setReviews] = useState([]);
  const count = supplier.ratingCount || 0;

  useEffect(() => {
    if (!supplier._id) return;
    api.get(`/api/suppliers/${supplier._id}/reviews`).then((res) => setReviews(res.data.reviews || [])).catch(() => {});
  }, [supplier._id]);

  return (
    <div className="border-t pt-3 space-y-2 text-sm">
      {showSummary && <div>
        {count ? t('supplierInfo.ratingSummary', { count, avg: Number(supplier.ratingAverage).toFixed(1) }) : <span className="text-gray-500">{t('groups.card.noReviews')}</span>}
      </div>}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={`supplier-reviews-${supplier._id}`}
        className="w-full flex items-center justify-between py-1 font-medium text-gray-800 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
      >
        <span>{t('supplierInfo.customerReviews', { count })}</span>
        <span aria-hidden="true">{open ? '▴' : '▾'}</span>
      </button>
      {open && (
        <ul id={`supplier-reviews-${supplier._id}`} className="space-y-2 max-h-[180px] overflow-y-auto pr-1">
          {reviews.map((r) => (
            <li key={r._id} className="border-b pb-2 last:border-b-0">
              <div aria-label={`${r.rating} out of 5 stars`} className="text-amber-500 leading-none">
                {'★'.repeat(r.rating)}<span className="text-gray-300">{'★'.repeat(5 - r.rating)}</span>
              </div>
              <div className="text-xs text-gray-500">{r.displayName || t('dialogs.review.anonymousCustomer')}</div>
              {r.comment && <p className="break-words text-gray-700 mt-1">{r.comment}</p>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
